export default {
  current: '',
  previous: '',
  menu_styles: {},
  mmenu : {
    shop_active: false
  }
}